export const AMP = 'AMP';
export const OP_A = 'OP_A';
export const OP_B1 = 'OP_B1';
export const OP_B2  = 'OP_B2';
export const OP_4 = 'OP_4';
export const PITCH = 'PITCH';
export const FILTER = 'FILTER';
export const FILTER_2 = 'FILTER_2';
export const MODULATION = 'MODULATION';

